/**
 * Utility to check if a field should be excluded from partial data capture
 * for privacy and security reasons (passwords, credit cards, etc.)
 */

const BLACKLISTED_TYPES = [
  'password',
  'credit-card',
  'ssn',
  'cvv',
  'cvc',
  'pin',
];

const BLACKLISTED_NAMES = [
  'password',
  'pwd',
  'pass',
  'passwd',
  'cc',
  'credit',
  'card',
  'cvv',
  'cvc',
  'ssn',
  'social',
  'pin',
  'secret',
  'token',
  'api_key',
  'apiKey',
  'apikey',
];

/**
 * Check if a field should be blacklisted from partial data capture
 */
export function isBlacklistedField(field: {
  componentType?: string;
  fieldId?: string;
  label?: string;
  name?: string;
}): boolean {
  const fieldType = (field.componentType || '').toLowerCase();
  const fieldId = (field.fieldId || '').toLowerCase();
  const fieldName = (field.name || '').toLowerCase();
  const fieldLabel = (field.label || '').toLowerCase();

  // Check type
  if (BLACKLISTED_TYPES.includes(fieldType)) {
    return true;
  }

  // Check if any identifier contains blacklisted words
  const fieldIdentifiers = [fieldId, fieldName, fieldLabel].join(' ');
  return BLACKLISTED_NAMES.some(
    (blacklisted) => fieldIdentifiers.includes(blacklisted)
  );
}
